import * as lazyIndex from './lazyIndex';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(
        /* webpackChunkName: "FocusedInboxRollup", webpackPrefetch: true */ './lazyIndex'
    )
);

export let lazyUpdateRollupForView = new LazyImport(lazyModule, m => m.updateRollupForView);
export let lazyGetFolderChangeDigest = new LazyImport(lazyModule, m => m.getFolderChangeDigest);
// used during mail bootstraping to initialize the rollup store.
export let lazyInitializeRollupStore = new LazyImport(lazyModule, m => m.initializeRollupStore);
export let lazyUpdateFocusedInboxRollupData = new LazyImport(
    lazyModule,
    m => m.updateFocusedInboxRollupData
);
export let lazySetRollupDismissState = new LazyAction(lazyModule, m => m.setRollupDismissState);
export let lazyUpdateWatermarkAndReset = new LazyAction(lazyModule, m => m.updateWatermarkAndReset);
